import {
	type ReactNode,
	createContext,
	useContext,
	useState,
	useEffect,
} from 'react'
import { io, type Socket } from 'socket.io-client'

const context = createContext<Socket | undefined>(undefined)

export function useSocket() {
	return useContext(context)
}

/**
 * Provider for a client side websocket.
 */
export function SocketProvider({ children }: { children: ReactNode }) {
	const [socket, setSocket] = useState<Socket>()
	const [isConnected, setIsConnected] = useState<boolean>(false)

	useEffect(() => {
		const socket = io()

		setSocket(socket)

		socket.on('connect', () => setIsConnected(true))
		socket.on('disconnect', () => setIsConnected(false))

		return () => {
			socket.close()
		}
	}, [])

	return (
		<context.Provider value={isConnected ? socket : undefined}>
			{children}
		</context.Provider>
	)
}
